import http from '../plugins/http'
import { handleApiError, validateHash } from './utils/errorHandler'

export async function verificarAtualizacoesPropostas ({
  id_comissionado,
  id_pedido,
  ultimo_hash
}) {
  if (!id_comissionado || typeof id_comissionado !== 'number') {
    throw new Error('verificarAtualizacoesPropostas: id_comissionado é obrigatório e deve ser um número')
  }

  if (id_pedido && typeof id_pedido !== 'number') {
    throw new Error('verificarAtualizacoesPropostas: id_pedido deve ser um número')
  }

  if (ultimo_hash && (typeof ultimo_hash !== 'string' || ultimo_hash.length !== 32)) {
    throw new Error('verificarAtualizacoesPropostas: ultimo_hash deve ser uma string de 32 caracteres (MD5)')
  }

  const params = {
    id_comissionado
  }

  if (id_pedido) {
    params.id_pedido = id_pedido
  }

  if (ultimo_hash) {
    params.ultimo_hash = ultimo_hash
  }

  try {
    const response = await http.get('/propostas/verificar-atualizacoes', {
      params,
      timeout: 10000,
      options: {
        silent: true,
        unguarded: false
      }
    })

    if (!response.data) {
      throw new Error('verificarAtualizacoesPropostas: Resposta da API está vazia')
    }

    const { tem_atualizacao, hash_atual, timestamp, quantidade_propostas } = response.data

    if (process.env.NODE_ENV === 'development') {
      if (typeof tem_atualizacao !== 'boolean') {
        console.warn('verificarAtualizacoesPropostas: tem_atualizacao não é booleano')
      }

      if (!hash_atual || typeof hash_atual !== 'string' || hash_atual.length !== 32) {
        console.warn('verificarAtualizacoesPropostas: hash_atual inválido')
      }

      if (!timestamp) {
        console.warn('verificarAtualizacoesPropostas: timestamp não fornecido')
      }

      if (typeof quantidade_propostas !== 'number') {
        console.warn('verificarAtualizacoesPropostas: quantidade_propostas não é número')
      }
    }

    return response
  } catch (error) {
    throw handleApiError(error, 'verificarAtualizacoesPropostas')
  }
}

export function usePropostasAPI () {
  return {
    verificarAtualizacoesPropostas
  }
}

export default {
  verificarAtualizacoesPropostas,
  usePropostasAPI
}
